import { Component } from "@angular/core";

@Component({
  selector: "app-sidebar-footer",
  templateUrl: "./app-sidebar-footer.component.html",
  styleUrls: ["./app-sidebar-footer.component.scss"],
})
export class AppSidebarFooterComponent {
  constructor() {}
}
